<template>
  <div class="component-content sub-content">
    <div class="list-title no-bottom-border">
      <div class="r">
        <!-- <el-button type="primary" @click="startCreate()" size="mini">添加资产</el-button> -->
      </div>
      <label class="label-name">所属公司：</label>
      <el-select size="small" :disabled="noSelectOrganization" class="organization-select" v-model="depId"
        placeholder="请选择所属公司">
        <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>

      <div class="item-input" style="display:inline-block;width:300px;">
        <label>搜索：</label>
        <el-input v-model="filterKey" size="mini" placeholder="你可以输入筛选资产编号/使用人/变更资产名称"></el-input>
      </div>
    </div>
    <div class="list-title">
      <el-row>
      </el-row>
    </div>

    <el-table :data="paginationData" style="width: 100%">
      <el-table-column label="变更单号" width="120px">
        <template slot-scope="scope">
          <a style="color: #175177;text-decoration: underline;" href="javascript:void(0)"
            @click="assetDetail(scope.row)">{{scope.row.number}}</a>
        </template>
      </el-table-column>
      <!-- changeAssets -->
      <el-table-column label="变更资产">
        <template slot-scope="scope">
          <span v-html="scope.row.changeAssets.map(item=>item.name).join()"></span>
          <!-- {{scope.row.changeAssets}} -->
        </template>
      </el-table-column>


      <el-table-column label="变更人" width="160px">
        <template slot-scope="scope">
          <user-info :userData='scope.row.changeUser'></user-info>
        </template>
      </el-table-column>

      <el-table-column prop="changeTime" label="变更时间" width="130px">
      </el-table-column>


      <el-table-column label="操作" width="60px">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="assetDetail(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

    <asset-change-detail></asset-change-detail>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import Role from '@/Mixins/role'
  import UserInfo from '@/components/UserInfo'
  import AssetChangeDetail from './assetChangeDetail'
  export default {
    mixins: [Role],
    components: {
      AssetChangeDetail,
      UserInfo,
    },
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        organizationListData: [],
        noSelectOrganization: true,
        depId: '',

        // 列表
        loading: true,
        pageSize: 50,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],

        // 筛选搜索
        teamId: 0,
        filterKey: "",
        teamArr: [],

        // 表格多选
        multipleSelection: []
      }
    },
    mounted() {
      console.log(this.organization.length > 0)

      // this.organizationListData.push({
      //   id: 0,
      //   name: "集团所有公司",
      //   depId: 0
      // })
      let _or = this.organization.length > 0 ? this.organization[0].childDepts : []
      this.organizationListData = this.organizationListData.concat(_or)

      this.depId = this.userData.secDepIds.split(",")[0] / 1

      if (this.depId == "7" || this.backRole('SYSTEM_1')) {
        this.noSelectOrganization = false
        // this.depId = 0
      }

      // 获取列表
      // this.getLists()
      // 获取项目组
      // this.getTeam()
    },
    methods: {
      // 显示详情
      assetDetail(row) {
        let assetChangeDetail = {
          status: true,
          data: row
        }
        this.$store.commit('set_assetChangeDetail', assetChangeDetail)
      },

      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选数据
      getFilterData() {
        console.log(this.filterName)
        if (this.teamId || this.filterKey) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.number.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1 || _new.changeUser.name
              .toLowerCase()
              .indexOf(this.filterKey.toLowerCase()) != -1 ||
              _new.name.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getLists() {
        ajax.get('/asset/change/list', {
          depId: this.depId
        }, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {
      'depId'() {
        this.getLists()
      },
      // 'teamId'() {
      //   this.getFilterData()
      // },
      'filterKey'() {
        this.getFilterData()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/asset/changeList.vue